import axios from "axios";
import { apiV1 } from "../lib/axios";

export async function getCNPJ(cnpj) {
    try {
      const empresa = await consultarCNPJ(cnpj);
      return empresa;
    } catch(err) {
      console.log('erro:', err);
      return err;
    }
}

async function consultarCNPJ(cnpj) {
  if (!cnpj) throw new Error("CNPJ não informado");

  cnpj = cnpj.replace(/[^0-9]/g, "");

  let company = await apiV1.get(`consult/cnpj/${cnpj}`);

  return company.data.data;
}
